import { Dispatch } from '../../../../../../../types/actions';
import { closeTimeTrackerDialog } from '../../../effects/closeTimeTrackerDialog';

export const onClose = () => {
    return (dispatch: Dispatch) => {
        dispatch(closeTimeTrackerDialog());
    }
}
